import { FloorsAPIType } from "shared/types/Project"

import { createSerializer } from "../createSerializer"
import { mapTypenameToAPIType } from "../mapTypenameToAPIType"

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function floorSerializer(data: any, headers: Headers) {
  if (Array.isArray(data)) {
    return createSerializer(FloorsAPIType)(data, headers)
  }

  return createSerializer(FloorsAPIType)(
    {
      ...data,
      parent: data.parent
        ? {
            id: data.parent.id,
            type: mapTypenameToAPIType(data.parent.type)
          }
        : undefined
    },
    headers
  )
}
